<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <!-- Main Content Area -->
            <div class="col-lg-10">
                <div class="blog-details-desc">
                    <!-- Premium Title -->
                    <div class="premium-page-header mb-5 text-center">
                        <h1 class="ultimate-3d-title">{{ inputData.ContentCategoryName }}</h1>
                        <div class="premium-header-divider mx-auto mt-3"></div>
                    </div>

                    <!-- Premium 3D Document List -->
                    <div class="premium-doc-list mt-4">
                        <div class="premium-doc-item" *ngFor="let item of inputData.ShowAttachments; let i = index">
                            <div class="doc-serial">{{ i + 1 | number:'2.0-0' }}</div>
                            <div class="doc-icon-box">
                                <i class="fa-solid fa-file-pdf"></i>
                            </div>

                            <div class="doc-info">
                                <a [href]="item.FilePath" target="_blank" class="doc-title">
                                    {{inputData.TitleEn}}
                                </a>
                                <div class="doc-meta">
                                    <span><i class="fa-regular fa-calendar-alt me-1"></i> Publish Date: {{
                                        inputData.CurrentDate | date : "MMMM d, yyyy" }}</span>
                                </div>
                            </div>

                            <div class="doc-actions">
                                <a href="#" (click)="openDocument(item.FilePath, $event)" class="btn-action btn-view"
                                    title="View Document">
                                    <i class="fa-solid fa-eye"></i>
                                </a>
                                <a [href]="item.FilePath" download class="btn-action btn-download"
                                    title="Download Document">
                                    <i class="fa-solid fa-download"></i>
                                </a>
                            </div>
                        </div>

                        <div *ngIf="!inputData.ShowAttachments || inputData.ShowAttachments.length === 0"
                            class="text-center p-5 text-muted border rounded"
                            style="background: #f8fafc; border-style: dashed !important;">
                            <i class="fa-regular fa-folder-open fs-1 mb-3" style="color: #cbd5e1;"></i>
                            <h5>No Documents Available</h5>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- Document Viewer Modal -->
<div class="doc-modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
    <div class="doc-modal-content" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="doc-modal-header">
            <h5 class="mb-0">Document Viewer</h5>
            <button class="doc-modal-close" (click)="closeModal()">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
        <!-- Body -->
        <div class="doc-modal-body">
            <!-- Loader (shows behind iframe while it loads, or as fallback) -->
            <div class="doc-modal-loader">
                <i class="fa-solid fa-circle-notch fa-spin fs-1"></i>
            </div>
            <iframe [src]="selectedDocumentUrl" class="doc-modal-iframe" frameborder="0"></iframe>
        </div>
    </div>
</div>